import React, { useEffect, useState } from 'react';
// Array of sample recent purchase notifications
const notifications = [{
  name: 'John D.',
  location: 'Texas',
  product: 'Premium Hardcover'
}, {
  name: 'Sarah M.',
  location: 'California',
  product: 'Physical Copy'
}, {
  name: 'Robert J.',
  location: 'Florida',
  product: 'Digital Copy'
}, {
  name: 'Emily W.',
  location: 'New York',
  product: 'Premium Hardcover'
}, {
  name: 'Michael K.',
  location: 'Ohio',
  product: 'Physical Copy'
}, {
  name: 'Jennifer L.',
  location: 'Virginia',
  product: 'Digital Copy'
}, {
  name: 'David P.',
  location: 'Michigan',
  product: 'Premium Hardcover'
}, {
  name: 'Lisa R.',
  location: 'Arizona',
  product: 'Physical Copy'
}, {
  name: 'Mark S.',
  location: 'Georgia',
  product: 'Digital Copy'
}, {
  name: 'Amy T.',
  location: 'Washington',
  product: 'Physical Copy'
}];
export const RecentSalesNotifications = () => {
  const [currentNotification, setCurrentNotification] = useState(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    // Function to show a random notification
    const showRandomNotification = () => {
      const randomIndex = Math.floor(Math.random() * notifications.length);
      setCurrentNotification(notifications[randomIndex]);
      setVisible(true);
      // Hide notification after 5 seconds
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };
    // Show first notification after 3 seconds
    const initialTimer = setTimeout(() => {
      showRandomNotification();
    }, 3000);
    // Set up interval to show notifications periodically
    const intervalTimer = setInterval(() => {
      showRandomNotification();
    }, 15000); // Show a new notification every 15 seconds
    // Clean up timers on unmount
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  if (!visible || !currentNotification) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs animate-fade-in-up" data-id="element-188">
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200 flex items-start" data-id="element-189">
        <div className="flex-shrink-0 mr-3" data-id="element-190">
          <div className="h-10 w-10 rounded-full bg-[#990000] flex items-center justify-center" data-id="element-191">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" data-id="element-192">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-193" />
            </svg>
          </div>
        </div>
        <div data-id="element-194">
          <p className="text-sm font-medium text-gray-900" data-id="element-195">
            {currentNotification.name} from {currentNotification.location}
          </p>
          <p className="text-xs text-gray-600" data-id="element-196">
            just purchased {currentNotification.product}
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-197">
            {Math.floor(Math.random() * 10) + 1} minute
            {Math.floor(Math.random() * 10) + 1 !== 1 ? 's' : ''} ago
          </p>
        </div>
      </div>
    </div>;
};